import { AsFoundFireTestSectionDataM71 } from './Data/M71/M71.data';

export const selectAsFoundFireTestSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (formName === 'M7-1') {
        filterViewData = AsFoundFireTestSectionDataM71(formData);
    }
    return filterViewData;
};
